import { connect } from 'react-redux'
import {
  setEmergencyContactFormField,
  setEmergencyContactForm
} from 'actions/account/emergencyContacts'
import { setErrorMessage } from 'actions/account'

const mapStateToProps = ({ emergencyContacts: { form } }) => ({ form })

const actions = {
  setEmergencyContactFormField,
  setEmergencyContactForm,
  setErrorMessage
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux
